import React from 'react';

import { ModalComponent } from 'baseComponents/ModalComponent';

import { TextComponent } from 'baseComponents/TextComponent';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { AudienceFiltersBrazeObject } from 'types/create-campaign';
import { ExistingFilterGroup } from 'screens/CreateCampaignScreen/components/ExistingFilterGroup';
import { useGetAttributesList } from 'hooks/useGetAttributesList';

interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  audienceName: string;
  audienceFilters: AudienceFiltersBrazeObject;
  audienceStores: {
    id: number;
    name: string;
  }[];
}

export const AudienceDetailsModal: React.FC<Props> = (props) => {
  const { data: attributesList } = useGetAttributesList();
  return (
    <ModalComponent
      title={`${props.audienceName || 'Audience'} details`}
      close={props.closeModal}
      open={props.isModalOpen}
    >
      {props.audienceStores && (
        <TextComponent
          text={`Selected stores: ${props.audienceStores
            .map((store) => `${store.name} (PJID: ${store.id})`)
            .join(', ')}`}
        />
      )}
      {attributesList && props.audienceFilters.AND && (
        <ExistingFilterGroup
          filtersGroup={props.audienceFilters.AND}
          attributesList={attributesList}
        />
      )}
      {!attributesList && !props.audienceFilters.AND && (
        <TextComponent text='No filters selected' />
      )}
      <ButtonComponent
        appereance='secondary'
        size='middle'
        onClick={props.closeModal}
        label='Cancel'
        fullWidth
      />
    </ModalComponent>
  );
};
